import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtpService {
 
  constructor(private http: HttpClient) { }

  sendOtp(data: any) {
    return this.http.post(environment.ccAgentWebApiUrl + 'api/CcOtp/SendOtp', data);
  }

  validateOtp(data: any) {
    return this.http.post(environment.ccAgentWebApiUrl + 'api/CcOtp/ValidateOtp', data);
  }
  
}
